export default __webpack_public_path__ + "static/media/zwergberg_memento_mori_cover.d4abcdd1.webp";